const AlignmentLeftModules = [
  'Teasers item',
  'Columns Item',
  'Moodboard Image',
  'Tabs item',
  'Explore brands item',
  'Slider item',
  'Palette item',
];
const AlignmentCenterModules = ['Color Shade'];

export const getOverlayAlignment = (moduleTitle: string) =>
  AlignmentLeftModules.includes(moduleTitle)
    ? 'left'
    : AlignmentCenterModules.includes(moduleTitle)
    ? 'center'
    : 'right';

const RespectOverflowModules = ['Slider item', 'Color Shade'];

export const getOverlayRespectOverflow = (moduleTitle: string) => RespectOverflowModules.includes(moduleTitle);

const VerticalAlignmentTop = ['Moodboard Image', 'Palette item', 'Teasers item'];

export const getOverlayVerticalAligment = (moduleTitle: string) =>
  VerticalAlignmentTop.includes(moduleTitle) ? 'top' : 'default';

export const getOverlayTitle = (moduleTitle: string) => {
  switch (moduleTitle) {
    case 'Columns Item':
      return 'Column';
    case 'Moodboard Image':
      return 'Element';
    case 'Teasers item':
      return 'Teaser';
    case 'Tabs item':
      return 'Tab';
    case 'Explore brands item':
      return 'Brand';
    case 'Slider item':
      return 'Slide';
    case 'Palette item':
      return 'Color';
    case 'HTML inline':
      return 'HTML';
    default:
      return moduleTitle;
  }
};
